module.exports = __webpack_public_path__ + "img/thumbnail_AlpineGoat_j_leucistic.315b5143.png";